<template>
  <div class="no-tabs sent-geo-modal">
    <div class="d-flex flex-column align-items-center justify-content-center mt-5">
      <label
        for="module-select"
        class="form-label"
      >{{ $t('modules.forms.select_form') }}:</label>
      <vue-select
        v-model="selectedValue"
        :options="formsList"
        class="flex-grow vue-select"
        icon="bi bi-ui-checks"
        label="name"
        @updateSelect="getForm"
      />

      <button
        class="btn btn-primary mt-5"
        :disabled="!selectedValue"
        @click="navigateToModule"
      >
        {{ $t('modules.forms.next') }}
      </button>
    </div>
    <div class="container-fluid mt-10">
      <div class="row">
        <div class="col-12 col-sm-6 mx-auto">
          <h5>{{ $t('modules.forms.form_history_head') }}</h5>
        </div>
        <div class="clearfix" />
        <div class="col-12 col-sm-6 mx-auto">
          <DxDataGrid
            :data-source="dataSource"
            key-expr="key"
            :show-borders="true"
          >
            <DxColumn
              data-field="formName"
              :caption="$t('modules.forms.list.form')"
            />
            <DxColumn
              data-field="createdAt"
              :caption="$t('modules.forms.list.createdAt')"
              data-type="date"
              format="yyyy-MM-dd HH:mm:ss"
            />
            <DxMasterDetail
              :enabled="true"
              template="master-detail"
            />
            <template #master-detail="{ data }">
              <div>
                {{ $t('modules.forms.form_history_table_head') }}:
                <li
                  v-for="(detail, index) in data.data.details"
                  :key="index"
                  class="list-group-item d-flex justify-content-between align-items-start small"
                >
                  <strong class="me-2">{{ detail.fieldName }}:</strong>
                  <span class="text-muted">{{ detail.value }}</span>
                </li>
              </div>
            </template>
          </DxDataGrid>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins';

.vue-select {
  width:400px;
  @include media-breakpoint-only(xs) {
    width: 100%;
  }
}

</style>

<script lang="ts">
import {defineComponent} from 'vue';
import {getForms, getRequiredForms, getUserHistory} from './crud';
import VueSelect from "@/components/extras/VueSelect.vue";
import {checkIfAdminOrBoss} from "@/utils/tools";
import {
  DxDataGrid,
  DxColumn,
  DxMasterDetail,
} from "devextreme-vue/data-grid";
import { loadMessages, locale } from 'devextreme/localization';
import messagesPl from '@/i18n/devextreme_pl.json';
import {useI18n} from "vue-i18n";
import {useQuasar} from "quasar";

export default defineComponent({
  name: 'ModulesForms',
  components: {VueSelect, DxDataGrid, DxColumn, DxMasterDetail},
  data() {
    return {
      moduleId: 1,
      pageTitle: this.$t('aside.menu.pages.modules.forms'),
      selectedValue: "",
      formsList: [],
      dataSource: [] as Array<any>,
    }
  },
  setup() {
    const { t } = useI18n()

    return {
      quasar: useQuasar(),
      t
    }
  },
  methods: {
    getForm(value): void {
      this.selectedValue = ""
      if (value) {
        this.selectedValue = 'form/' + value.hash
      }
    },
    navigateToModule() {
      if (this.selectedValue) {
        this.$router.push(`/modules/forms/${this.selectedValue}`);
      }
    },
    getRequiredForms() {
      getRequiredForms()
          .then((res) => {
            if(res.data?.hash) {
              this.$router.push(`/modules/forms/form/${res.data?.hash}`);
            } else {
              this.getForms()
            }
          })
          .catch(() => {
            this.$toast.error(this.$t('components.error'))
          })
    },
    getForms() {
      getForms()
        .then((res) => {
          this.formsList = res.data
        })
        .catch(() => {
          this.$toast.error(this.$t('components.error'))
        })
    },
    getUserHistory() {
      getUserHistory()
          .then((res) => {
            this.dataSource = res.data
          })
          .catch(() => {
            this.$toast.error(this.$t('components.error'))
          })
    }
  },
  mounted() {
    if(!checkIfAdminOrBoss()) {
      this.getRequiredForms();
    } else {
      this.getForms();
    }

    this.getUserHistory();
    if(this.$i18n.locale === 'pl') {
      loadMessages(messagesPl);
      locale(this.$i18n.locale)
    }
  },
  beforeMount() {
    this.$emit('pageName', this.pageTitle)
    document.title = document.title + ' ' + this.pageTitle
    this.$emit('emitGetComponentId', this.moduleId)
  }
})
</script>